export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/guided-setup.9d60f40e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};